import React, { useCallback } from 'react'
import { I18n } from '@front/volcanion/'
import { TableHeader, TableRow, SearchFrame, SearchForm, SearchTable, FormContent } from '@front/squirtle'

import { Box, Typography, StepLabel, StepContent } from '@mui/material'

import Callbacks from './callbacks'
import Form from './Form'
import Header from './Header'
import Row from './Row'

const OrderLimitationSection = ({ model_name, record_id, parentModelName, enableSubmitAll, company, disableTarget }) => {
  const formToFilter = useCallback(Callbacks.formToFilterHandler(parentModelName, record_id, company), [parentModelName, record_id, company])
  const formToRecord = useCallback(Callbacks.formToRecordHandler(parentModelName, record_id, company), [parentModelName, record_id, company])
  const getEmptyForm = useCallback(Callbacks.getEmptyFormHandler(parentModelName), [parentModelName])

  return <>
    <StepLabel>
      <Typography variant='h5'>{I18n.t('order_limit.label')}</Typography>
    </StepLabel>
    <StepContent>
      <Box sx={{ p: 2, boxShadow: 6, borderRadius: 1 }}>
        <SearchFrame
          model_name={model_name}
          populate={['orderlimit']}
          allowCreate={false}
          createPlacement={'bottom'}
        >
          <SearchForm
            formToFilter={formToFilter}
            submitOnMount
            disableButton
          >
            <FormContent><Form /></FormContent>
          </SearchForm>
          <SearchTable
            formProps={{
              formToRecord,
              getEmptyForm,
              disableParentSubmitListener: true,
              closeOnSuccess: true,
              submitChangesOnly: false
            }}
            formActionsProps={{
              enableSubmitAll
            }}
            tableProps={{
              onRowClick: null,
              allowEditMode: true,
              enablePagination: false,
              enableRowActions: true,
              enableGlobalActions: true,
              addRowLabel: I18n.t('order_limit.label'),
              enableGlobalActionsPlacement: 'bottom',
            }}
          >
            <TableHeader><Header disableTarget={disableTarget} /></TableHeader>
            <TableRow><Row disableTarget={disableTarget} parentModelName={parentModelName} company={company} /></TableRow>
          </SearchTable>
        </SearchFrame>
      </Box>
    </StepContent>
  </>
}

export default React.memo(OrderLimitationSection)
